import { render, staticRenderFns } from "./IP.vue?vue&type=template&id=24730f1e"
import script from "./IP.vue?vue&type=script&lang=js"
export * from "./IP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports